import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appEzInput]',
  standalone: true,
})
export class EzInputDirective {
  constructor(
    public elementRef: ElementRef,
    public control: NgControl,
  ) {}

  @Output() focused: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostListener('focusin')
  onFocusIn(){
    this.focused.emit(true)
  }

  @HostListener('focusout')
  onFocusOut(){
    this.focused.emit(false)
  }
}
